<div (click)="locationBack()">
    <svg-icon src="assets/svg/history-back-arrow-left-gray.svg" class="mr-2 c-pointer"></svg-icon>
    <a class="history-back">Voltar para o menu anterior</a>
</div>